// import "moment/locale/th";

import React, { useEffect, useState } from "react";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

function SupplyDemand(props) {
  // console.log(props);
  const dispatch = useDispatch();
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (typeof number == "string") {
      // console.log(number)
      if (number.includes("+")) {
        return (
          "+ " +
          parseFloat(
            parseFloat(
              number.replaceAll(",", "").replaceAll("+", "").trim()
            ).toFixed(digit)
          ).toLocaleString(undefined, {
            minimumFractionDigits: digit,
          })
        );
      }
      if (number.includes("-")) {
        return (
          "- " +
          parseFloat(
            parseFloat(
              number.replaceAll(",", "").replaceAll("-", "").trim()
            ).toFixed(digit)
          ).toLocaleString(undefined, {
            minimumFractionDigits: digit,
          })
        );
      }
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const ToNumberFormat = (cell, row, rowIndex) => numberFormat(cell, 0);
  const [columnsSummary, setColumnsSummary] = useState([
    {
      dataField: "SUPPLYDEMAND_NAME",
      text: "",
      headerAlign: "center",
      align: "center",

      headerStyle: {
        backgroundColor: "#3A4473", //5365BD
        color: "#FEF6AA",
        fontSize: "1vw",
        width: "10%",
        fontWeight: "bold",
      },
      style: {
        width: "10%",
        fontWeight: "bold",
        fontSize: "1vw",
      },
      // sort: true,
    },
    {
      dataField: "SUPPLY_PLAN_ENTRY",
      text: "Planned Entry",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        // console.log(row)
        let className = "";
        if (row.ENTRY_groups != null)
          className = `SUPPLY_PLAN_ENTRY ${row.ENTRY_groups} rowspan${row.ENTRY_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#466597", //5365BD
        color: "#FEF6AA",
        fontSize: "1vw",
        fontWeight: "bold",
        width: "15%",
      },
      style: {
        width: "15%",
        fontSize: "1vw",
        fontWeight: "bold",
      },
      // sort: true,
      formatter: ToNumberFormat,
    },
    {
      dataField: "SUPPLY_ACTUAL_ENTRY",
      text: "Actual Entry",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.ENTRY_groups != null)
          className = `SUPPLY_ACTUAL_ENTRY ${row.ENTRY_groups} rowspan${row.ENTRY_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#466597", //5365BD
        color: "#FEF6AA",
        fontSize: "1vw",
        width: "15%",
      },
      style: {
        width: "15%",
        fontSize: "1vw",
        fontWeight: "bold",
      },
      // sort: true,
      formatter: ToNumberFormat,
    },
    {
      dataField: "SUPPLY_DIFF_ENTRY",
      text: "Diff Entry",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.ENTRY_groups != null)
          className = `SUPPLY_DIFF_ENTRY ${row.ENTRY_groups} rowspan${row.ENTRY_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#466597", //5365BD
        color: "#FEF6AA",
        fontSize: "1vw",
        width: "15%",
        fontWeight: "bold",
      },
      style: {
        width: "15%",
        fontSize: "1vw",
        fontWeight: "bold",
      },
      // sort: true,
      formatter: ToNumberFormat,
    },
    {
      dataField: "DEMAND_PLAN_EXIT",
      text: "Planned Exit",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.EXIT_groups != null)
          className = `DEMAND_PLAN_EXIT ${row.EXIT_groups} rowspan${row.EXIT_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#466597", //5365BD
        color: "#FEF6AA",
        fontSize: "1vw",
        width: "15%",
        fontWeight: "bold",
      },
      style: {
        width: "15%",
        fontWeight: "bold",
        fontSize: "1vw",
      },
      // sort: true,
      formatter: ToNumberFormat,
    },
    {
      dataField: "DEMAND_ACTUAL_EXIT",
      text: "Actual Exit",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.EXIT_groups != null)
          className = `DEMAND_ACTUAL_EXIT ${row.EXIT_groups} rowspan${row.EXIT_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#466597", //5365BD
        color: "#F7EFA4",
        fontSize: "1vw", //0.65vw
        width: "15%",
        fontWeight: "bold",
      },
      style: {
        width: "15%",
        fontWeight: "bold",
        fontSize: "1vw",
      },
      // sort: true,
      formatter: ToNumberFormat,
    },
    {
      dataField: "DEMAND_DIFF_EXIT",
      text: "Diff Exit",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.EXIT_groups != null)
          className = `DEMAND_DIFF_EXIT ${row.EXIT_groups} rowspan${row.EXIT_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#466597", //5365BD
        color: "#F7EFA4",
        fontSize: "1vw",
        width: "15%",
        fontWeight: "bold",
      },
      style: {
        width: "15%",
        fontWeight: "bold",
        fontSize: "1vw",
      },
      formatter: ToNumberFormat,
      // sort: true,
    },
  ]);

  const rowStyleSummary = (row, rowIndex) => {
    const style = {};
    if (rowIndex == props.modelDeviceList.length - 1) {
      style.backgroundColor = "#466597";  //556ee64a
      style.color = "#FFFFFF";
    } else {
      style.color = "#FFFFFF";
    }
    style.fontSize = "1vw";
    style.height = "10vh";
    style.verticalAlign = "middle";
    return style;
  };

  //headerColumn
  useEffect(() => {
    let classMerged = [];
    function mergeCell(index) {
      if (classMerged.indexOf($(this).attr("class")) == -1) {
        let [field, group, rowspan] = $(this).attr("class")?.split(/\s+/);
        $(this).attr("rowspan", rowspan.replaceAll("rowspan", ""));
        $(`.${field}.${group}.${rowspan}`).not(":first").hide();
      }
      classMerged.push($(this).attr("class"));
    }
    $(".SUPPLY_PLAN_ENTRY").each(mergeCell);
    $(".SUPPLY_ACTUAL_ENTRY").each(mergeCell);
    $(".SUPPLY_DIFF_ENTRY").each(mergeCell);
    $(".DEMAND_PLAN_EXIT").each(mergeCell);
    $(".DEMAND_ACTUAL_EXIT").each(mergeCell);
    $(".DEMAND_DIFF_EXIT").each(mergeCell);
  }, [props.modelDeviceList]);

  return (
    <BootstrapTable
      id="suply-demand-table"
      wrapperClasses="table-on-scroll"
      keyField="SUPPLYDEMAND_NAME"
      data={props.modelDeviceList}
      columns={columnsSummary}
      rowStyle={rowStyleSummary}
      headerClasses="header-style"
    />
  );
}

SupplyDemand.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
  modelDeviceList: PropTypes.any,
};

export default SupplyDemand;
